import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_BOTON_LISTAR_ATRAS } from "../../utils/const/estilos-const";
import { crearUsuarioMovil, modificarUsuarioMovil, obtenerListaUsuariosMovil, } from "../../api/usuario";
import Select from "react-select";
import { obtenerTodasLasUnidades } from "../../api/gestion-dts/gestion";
// import { INT_TIPO_USUARIO_SUPERVISOR_MOVIL } from "../../utils/const/int-const";
import "../../style/style-cargando.css";
import { obtenerListaTipoUsuarioMovil } from "../../api/tipo-usuario-movil";
import cargandoCard from "../../components/cargando-card";
import sinDataCard from "../../components/sin-data-card";
import { useTranslation } from "react-i18next";
import { obtenerListaGrupos, obtenerListaSubGrupos } from "../../api/gestion-dts/api-rastreo-v4";
import ProcessingDialog from "../../components/processing-dialog";

export default function UsuarioMovil() {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [titulo, setTitulo] = useState(t('titulo_crear_usuario_movil'));

  const [listaUnidades, setListaUnidades] = useState([]);
  const [unidadesSelected, setUnidadesSelected] = useState(null);

  const [listaTipoUsuarioMovil, setListaTipoUsuarioMovil] = useState([]);
  const [tipoUsuarioMovilSelected, setTipoUsuarioMovilSelected] = useState(null);

  const [listaGrupos, setListaGrupos] = useState([]);
  const [grupoSelected, setGrupoSelected] = useState(null);

  const [listaSubGrupos, setListaSubGrupos] = useState([]);
  const [subGrupoSelected, setSubGrupoSelected] = useState(null);

  const [sendRequest, setSendRequest] = useState(false);

  useEffect(() => {
    // console.log("entro a UsuarioMovil");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setUsuario(data.params);
        setTitulo(data.titulo);

        let tiposUsuarioMovil = await obtenerListaTipoUsuarioMovil(true)
        // console.log('tiposUsuarioMovil');
        // console.log(tiposUsuarioMovil);
        setListaTipoUsuarioMovil(tiposUsuarioMovil);
        if (data.params.idTipoUsuarioMovil !== null) {
          const tipoUsuario = tiposUsuarioMovil.find(e => e.value === data.params.idTipoUsuarioMovil);
          if (tipoUsuario !== undefined) {
            setTipoUsuarioMovilSelected(tipoUsuario);
          }
        }

        let todasLasUnidades = await obtenerTodasLasUnidades();
        // console.log('todasLasUnidades');
        // console.log(todasLasUnidades);
        if (data.params.valueUnidad !== null) {
          const unidad = todasLasUnidades.find(e => e.value === data.params.valueUnidad);
          if (unidad !== undefined) {
            setUnidadesSelected(unidad);
          }
        }
        let listaUsuarioMovil = await obtenerListaUsuariosMovil();
        // console.log('listaUsuarioMovil');
        // console.log(listaUsuarioMovil);
        const unidadesFiltradas = todasLasUnidades.filter(objA => !listaUsuarioMovil.some(objB => objB.unidad === objA.value));
        setListaUnidades(unidadesFiltradas);

        let listaGruposEmpresa = await obtenerListaGrupos();
        // console.log('listaGruposEmpresa');
        // console.log(listaGruposEmpresa);
        if (listaGruposEmpresa.error === false && Array.isArray(listaGruposEmpresa.data) && listaGruposEmpresa.data.length > 0) {
          setListaGrupos(listaGruposEmpresa.data);
        }
        // setListaGrupos(listaGrupos);
        if (data.params.grupo !== null) {
          const grupo = JSON.parse(data.params.grupo);
          if (grupo !== undefined) {
            setGrupoSelected(grupo);
          }
        }
        if (data.params.subGrupo !== null) {
          const subGrupo = JSON.parse(data.params.subGrupo);
          if (subGrupo !== undefined) {
            setSubGrupoSelected(subGrupo);
          }
        }
        if (data.params.listaVehiculos !== null) {
          const listaVehiculos = JSON.parse(data.params.listaVehiculos);
          if (listaVehiculos !== undefined) {
            setUnidadesSelected(listaVehiculos);
          }
        }
      }
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const handleInputChange = (event) => {
    // console.log('handleInputChange');
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    setUsuario({ ...usuario, [name]: value });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const handleAceptarClick = async () => {
    try {
      // console.log('handleAceptarClick');
      // lógica para guardar los cambios
      // console.log('usuario');
      // console.log(usuario);
      let valido = await validarUsuario();
      // console.log('valido');
      // console.log(valido);
      if (valido === false) {
        return;
      }
      let objEnviar = {};
      objEnviar.id = usuario.id;
      objEnviar.nombre = usuario.nombre;
      objEnviar.apellidoPaterno = usuario.apellidoPaterno;
      objEnviar.apellidoMaterno = usuario.apellidoMaterno;
      objEnviar.numeroLicConducir = usuario.numeroLicConducir;
      objEnviar.telefono = usuario.telefono;
      objEnviar.usuario = usuario.usuario;
      objEnviar.contrasena = usuario.contrasena;
      objEnviar.nota = usuario.nota;

      objEnviar.grupo = grupoSelected;
      objEnviar.subGrupo = subGrupoSelected;
      objEnviar.listaVehiculos = unidadesSelected;

      objEnviar.idTipoUsuarioMovil = null;
      if (tipoUsuarioMovilSelected !== null) {
        objEnviar.idTipoUsuarioMovil = tipoUsuarioMovilSelected.value;
      }
      if (usuario.id <= 0) {
        // console.log('crear correo');
        const creado = await crearUsuarioMovil(objEnviar);
        // console.log('creado');
        // console.log(creado);
        if (creado === true) {
          alert(t('alert_se_creo_correctamente'));
          history.goBack();
        }
        if (creado === false) {
          alert(t('alert_no_se_pudo_procesar'));
        }
      }
      if (usuario.id !== 0) {
        // console.log('actualizar correo');
        const modificado = await modificarUsuarioMovil(objEnviar);
        // console.log('modificado');
        // console.log(modificado);
        if (modificado === true) {
          alert(t('alert_se_modifico_correctamente'));
          history.goBack();
        }
        if (modificado === false) {
          alert(t('alert_no_se_pudo_procesar'));
        }
      }
    } catch (err) {
      console.log('handleAceptarClick err');
      console.log(err);
      // alert('No se pudo continuar, por favor revise los campos');
    }
  };

  const validarUsuario = async () => {
    try {
      let error = '';
      if (usuario === undefined || usuario === null) {
        error = error + t('alert_debe_ingresar_datos') + '\n';
      }
      // if (tipoUsuarioMovilSelected === null) {
      //   error = error + t('alert_debe_seleccionar_tipo_usuario_movil') + '\n';
      // }
      if (usuario.nombre === undefined === usuario.nombre === null || String(usuario.nombre).length === 0) {
        error = error + t('alert_debe_ingresar_nombre') + '\n';
      }
      if (usuario.apellidoPaterno === undefined === usuario.apellidoPaterno === null || String(usuario.apellidoPaterno).length === 0) {
        error = error + t('alert_debe_ingresar_apellido_paterno') + '\n';
      }
      if (usuario.apellidoMaterno === undefined === usuario.apellidoMaterno === null) {
        usuario.apellidoMaterno = '';
      }
      if (usuario.numeroLicConducir === undefined === usuario.numeroLicConducir === null) {
        usuario.numeroLicConducir = '';
      }
      if (usuario.usuario === undefined === usuario.usuario === null || String(usuario.usuario).length === 0) {
        error = error + t('alert_debe_ingresar_usuario') + '\n';
      }
      if (usuario.contrasena === undefined === usuario.contrasena === null || String(usuario.contrasena).length === 0) {
        error = error + t('alert_debe_ingresar_password') + '\n';
      }
      if (usuario.telefono === undefined || usuario.telefono === null) {
        usuario.telefono = '';
      }
      if (usuario.nota === undefined || usuario.nota === null) {
        usuario.nota = '';
      }
      if (String(error).length === 0) {
        return true;
      }
      if (String(error).length > 0) {
        alert(error);
      }
      return false;
    } catch (err) {
      console.log('validarUsuario err');
      console.log(err);
      return false;
    }
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  // const handleunidadesSelected = async (event) => {
  //   try {
  //     if (event !== null) {
  //       // console.log('event');
  //       // console.log(event);
  //       let obj = {};
  //       obj.idActivo = event.value;
  //       let infoConductor = await obtenerInfoConductorConNumeroPlaca(obj);
  //       // console.log('infoConductor');
  //       // console.log(infoConductor);
  //       if (infoConductor !== null) {
  //         setUsuario(prevUsuario => ({
  //           ...prevUsuario,
  //           nombre: infoConductor.nombre || "",
  //           apellidoPaterno: infoConductor.apellidoPaterno || "",
  //           apellidoMaterno: infoConductor.apellidoMaterno || "",
  //           numeroLicConducir: infoConductor.nroLicConducir || "",
  //           telefono: infoConductor.nroCelPersonal || ""
  //         }));
  //       }
  //       if (infoConductor === null) {
  //         resetInfoUsuario();
  //       }

  //     }
  //     setUnidadesSelected(event);
  //   } catch (err) {
  //     console.log('handleunidadesSelected err');
  //     console.log(err);
  //   }
  // };

  const handleTipoUsuarioMovilSelected = (event) => {
    try {
      setTipoUsuarioMovilSelected(event);
    } catch (err) {
      console.log('handleTipoUsuarioMovilSelected err');
      console.log(err);
    }
  };

  // const resetInfoUsuario = () => {
  //   const camposAResetear = [
  //     'nombre',
  //     'apellidoPaterno',
  //     'apellidoMaterno',
  //     'numeroLicConducir',
  //     'telefono'
  //   ];

  //   setUsuario(prevUsuario =>
  //     camposAResetear.reduce((nuevoUsuario, campo) => {
  //       nuevoUsuario[campo] = '';
  //       return nuevoUsuario;
  //     }, { ...prevUsuario })
  //   );
  // };

  useEffect(() => {
    setListaSubGrupos([]);
    // setSubGrupoSelected(null);
    if (grupoSelected !== null) {
      obtenerListaSubGrupo();
    }
  }, [grupoSelected]);

  const obtenerListaSubGrupo = async () => {
    try {
      setSendRequest(true);
      let listaSubGrupos = await obtenerListaSubGrupos({ idGrupo: grupoSelected.value });
      // console.log('listaSubGrupos');
      // console.log(listaSubGrupos);
      if (listaSubGrupos.error === false && Array.isArray(listaSubGrupos.data) && listaSubGrupos.data.length > 0) {
        setListaSubGrupos(listaSubGrupos.data);
      }
    } catch (err) {
      console.log('obtenerListaSubGrupos err');
      console.log(err);
    } finally {
      setSendRequest(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (cargandoPage === false && usuario === null) {
        return sinDataCard();
      }
      return (
        <div className="pt-4 px-4 " >
          <div
            style={{
              paddingTop: 5,
              paddingBottom: 5,
              paddingRight: 10,
              paddingLeft: 10,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <label
              style={{
                paddingLeft: 4,
                fontWeight: 'bold',
              }}
            >
              {titulo}
            </label>
            <button
              type="button"
              className={ESTILO_BOTON_LISTAR_ATRAS}
              onClick={handleAtrasClick}
            >
              {t('btn_atras')}
            </button>
          </div>
          <hr />
          <br />
          <div class="grid grid-cols-12 gap-4">

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label htmlFor="unidad" className="mb-2 font-bold">
                {t('label_tipo_usuario_movil')}
              </label>
              <Select options={listaTipoUsuarioMovil} isSearchable='true'
                isClearable='true'
                value={tipoUsuarioMovilSelected}
                onChange={(event) => handleTipoUsuarioMovilSelected(event)}
                placeholder={t('select_seleccione_tipo_usuario')}
              />
            </div>

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label htmlFor="unidad" className="mb-2 font-bold">
                {t('label_grupo')}
              </label>
              <Select
                options={listaGrupos}
                isSearchable={true}
                isClearable={true}
                value={grupoSelected}
                onChange={(event) => setGrupoSelected(event)}
                placeholder={t('placeholder_select_seleccione_grupo')}
              />
            </div>

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label htmlFor="unidad" className="mb-2 font-bold">
                {t('label_sub_grupo')}
              </label>
              <Select
                options={listaSubGrupos}
                isSearchable={true}
                isClearable={true}
                value={subGrupoSelected}
                onChange={(event) => setSubGrupoSelected(event)}
                placeholder={t('placeholder_select_seleccione_sub_grupo')}
              />
            </div>

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label htmlFor="unidad" className="mb-2 font-bold">
                {t('label_lista_unidades')}
              </label>
              <Select
                options={listaUnidades}
                isSearchable={true}
                isClearable={true}
                value={unidadesSelected}
                isMulti={true}
                onChange={(event) => setUnidadesSelected(event)}
                placeholder={t('placeholder_select_seleccione_unidades')}
              />
            </div>

          </div>
          <br />
          <hr />
          <div class="grid grid-cols-12 gap-4">

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label htmlFor="nombre" className="mb-2 font-bold">
                  {t('label_nombre')}<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  value={usuario.nombre}
                  onChange={handleInputChange}
                  placeholder={t('label_nombre')}
                  className="p-2 border border-gray-300 rounded"
                  maxLength={100}
                />
              </div>
            </div>

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label htmlFor="apellidoPaterno" className="mb-2 font-bold">
                  {t('label_apellido_paterno')}<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="apellidoPaterno"
                  name="apellidoPaterno"
                  value={usuario.apellidoPaterno}
                  onChange={handleInputChange}
                  placeholder={t('label_apellido_paterno')}
                  className="p-2 border border-gray-300 rounded"
                  maxLength={100}
                />
              </div>
            </div>

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label htmlFor="apellidoMaterno" className="mb-2 font-bold">
                  {t('label_apellido_materno')}
                </label>
                <input
                  type="text"
                  id="apellidoMaterno"
                  name="apellidoMaterno"
                  value={usuario.apellidoMaterno}
                  onChange={handleInputChange}
                  placeholder={t('label_apellido_materno')}
                  className="p-2 border border-gray-300 rounded"
                  maxLength={100}
                />
              </div>
            </div>

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label htmlFor="numeroLicConducir" className="mb-2 font-bold">
                  {t('label_numero_lic_conducir')}
                </label>
                <input
                  type="text"
                  id="numeroLicConducir"
                  name="numeroLicConducir"
                  value={usuario.numeroLicConducir}
                  onChange={handleInputChange}
                  placeholder={t('label_numero_lic_conducir')}
                  className="p-2 border border-gray-300 rounded"
                  maxLength={45}
                />
              </div>
            </div>

          </div>
          <br />
          <div class="grid grid-cols-12 gap-4">

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label htmlFor="telefono" className="mb-2 font-bold">
                  {t('label_telefono')}
                </label>
                <input
                  type="text"
                  id="telefono"
                  name="telefono"
                  value={usuario.telefono}
                  onChange={handleInputChange}
                  placeholder={t('label_telefono')}
                  className="p-2 border border-gray-300 rounded"
                  maxLength={45}
                />
              </div>
            </div>

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">

              <div
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label htmlFor="usuario" className="mb-2 font-bold">
                  {t('label_usuario')}<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="usuario"
                  name="usuario"
                  value={usuario.usuario}
                  onChange={handleInputChange}
                  placeholder={t('label_usuario')}
                  className="p-2 border border-gray-300 rounded"
                  maxLength={45}
                />
              </div>
            </div>

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label htmlFor="contrasena" className="mb-2 font-bold">
                  {t('label_contrasena')}<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="contrasena"
                  name="contrasena"
                  value={usuario.contrasena}
                  onChange={handleInputChange}
                  placeholder={t('label_contrasena')}
                  className="p-2 border border-gray-300 rounded"
                  maxLength={45}
                />
              </div>
            </div>

          </div>

          <br />
          <div class="grid grid-cols-12 gap-4">

            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <label htmlFor="nota" className="mb-2 font-bold">
                  {t('label_nota')}
                </label>
                <textarea
                  type="text"
                  id="nota"
                  name="nota"
                  value={usuario.nota}
                  onChange={handleInputChange}
                  rows={3}
                  placeholder={t('label_nota')}
                  className="p-2 border border-gray-300 rounded"
                  maxLength={512}
                />
              </div>
            </div>

          </div>
          <br />
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
              <div class="flex justify-between">
                <button className={ESTILO_BOTON_GENERAL_CANCELAR}
                  onClick={handleCancelClick}
                >
                  {t('btn_cancelar')}
                </button>
                <button className={ESTILO_BOTON_GENERAL_ACEPTAR}
                  onClick={handleAceptarClick}
                >
                  {t('btn_aceptar')}
                </button>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={sendRequest} message={t("alert_procesando_solicitud")} />
        </div>
      );
    } catch (err) {
      console.log('UsuarioMovil render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
